<template>
    <a class="flex-no-shrink lg:pb-2 text-center flex flex-col justify-between mr-4 mb-4 bg-white cursor-pointer text-center w-8 lg:w-24 border-2 border-white hover:bg-blue-lightest shadow rounded hover:border-blue-dark focus:outline-none"
       :class="{'text-grey-darkest bg-blue-lightest border-blue-lighter': active, 'text-grey-dark': !active}">
        <div class="px-2 pt-2">
            <img class="w-24" :src="img">
        </div>
        <div class="text-sm hidden lg:block">
            <slot></slot>
        </div>
    </a>
</template>

<script>
    export default {
        props: ['active', 'img']
    }
</script>
